// extracted by mini-css-extract-plugin
module.exports = {"container":"DiscardPile_container__p_vB2","pile":"DiscardPile_pile__2QlQQ","policy":"DiscardPile_policy__YPEEC","badge":"DiscardPile_badge__2h0WH"};